var N = /* @__PURE__ */ ((r) => (r.Cs = "CS", r.Da = "DA", r.De = "DE", r.En = "EN", r.Es = "ES", r.Fi = "FI", r.Fr = "FR", r.It = "IT", r.Nb = "NB", r.Nl = "NL", r.Pl = "PL", r.Pt = "PT", r.Sv = "SV", r.Tr = "TR", r))(N || {});
export {
  N as LocaleEnum
};
//# sourceMappingURL=locales.mjs.map
